// Libs
import _reduce from 'lodash/reduce'

// Types
import type {
  Json,
} from 'fc-flow-types/models'

type Decoder = (value: mixed, any, any) => any
type Decoders = { [string]: Decoder }
type Model = { [string]: any }

export default function createDecoder (decoders: Decoders) {
  return function (maybeModel: ?Json) {
    const model: Json = maybeModel == null ? {} : maybeModel

    return _reduce(decoders, (acc: Model, decode: Decoder, property: string) => {
      acc[property] = decode(model[property], model, decoders)
      return acc
    }, {})
  }
}
